export default {
    set(name, value, seconds = 0) {
        let date = new Date();
        date.setTime(date.getTime() + seconds );
        document.cookie = name + "=" + value + "; path=/; SameSite=None" + (seconds ? '; expires=' + date.toGMTString() : '; domain=' + window.location.hostname);
    },
    get(name) {
        let value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return value ? value[2] : null;
    },
};



